'use client';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

const Home = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace('/auth/login');
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only redirect; router is stable per render but adding it would re-run on every router change with no benefit
  }, []);
  return null;
};
export default Home;
